import type { ReactNode } from 'react'
import React from 'react'

import { Stack } from '../../../layout'
import { StyledMenuSectionTitle } from './MenuSection.styles'

export interface MenuSectionProps {
  'data-e2e'?: string
  children?: ReactNode
  isVisible?: boolean
  title?: string
}

const MenuSection = ({
  'data-e2e': dataE2e = 'menu-section',
  children,
  isVisible = true,
  title,
}: MenuSectionProps) =>
  isVisible ? (
    <Stack data-e2e={dataE2e} spacing="small">
      {!!title && (
        <StyledMenuSectionTitle
          data-e2e={`${dataE2e}--title`}
          fontCase="uppercase"
          bold
          size="small"
        >
          {title}
        </StyledMenuSectionTitle>
      )}

      {children}
    </Stack>
  ) : null

export default MenuSection
